"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XSSTooltip = exports.getSafeUrl = exports.isUnsafeUrl = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

/* eslint-disable no-script-url */
var NOOP_HREF = 'javascript:void(0)'; // Match the protocol part of an absolute URL, e.g. "http:"

var PROTOCOL_REGEX = /^([^:]+):/; // Whitespace and control characters are ignored, so we must strip them out
// eslint-disable-next-line no-control-regex

var IGNORED_PROTOCOL_CHARS_REGEX = /[\s\x00-\x1f]/g;

var isUnsafeUrl = function isUnsafeUrl(href) {
  if (href && typeof href === 'string') {
    var protocolMatch = href.match(PROTOCOL_REGEX);
    if (!protocolMatch || href === NOOP_HREF) return false;

    if (protocolMatch[0].replace(IGNORED_PROTOCOL_CHARS_REGEX, '').toLowerCase() === 'javascript:') {
      return true;
    }
  }

  return false;
};

exports.isUnsafeUrl = isUnsafeUrl;

var getSafeUrl = function getSafeUrl(href) {
  if (href && typeof href === 'object' && typeof href.safeHref === 'string') {
    return href.safeHref;
  }

  return isUnsafeUrl(href) ? NOOP_HREF : href;
};

exports.getSafeUrl = getSafeUrl;
var XSSTooltip = (0, _Controllable.default)(function (_ref) {
  var children = _ref.children,
      onOpenChange = _ref.onOpenChange,
      open = _ref.open;

  var child = _react.Children.only(children);

  return _react.default.createElement(_UITooltip.default, {
    open: open,
    title: _I18n.default.text('salesUI.XSSTooltip.explanation'),
    use: "danger"
  }, _react.default.cloneElement(child, {
    href: NOOP_HREF,
    onClick: function onClick(evt) {
      child.props.onClick(evt);
      onOpenChange((0, _SyntheticEvent.default)(!open));
    }
  }));
}, ['open']);
exports.XSSTooltip = XSSTooltip;